import Moment from 'moment'
import PropTypes from 'prop-types'
import { useState, useEffect, useRef, useCallback, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Events, scroller } from 'react-scroll'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { setModal } from '../../slices/modalSlice'
import { LoginContext } from '../context/loginContext'
import { withValidador } from '../hoc/withValidador'
import Metadatos from '../publicaciones/Metadatos'
import { GenericModal } from '../reutilizables/modal/GenericModal'
import * as publicacionService from '../servicios/publicacionesTemporalesService'
import LinkButton from '../ui/LinkButton'
import AgregarFotos from './AgregarFotos'
import AsistenteFlechas from './AsistenteFlechas'
import Borde from './Borde'
import CategoriasPrincipales from './CategoriasPrincipales'
import DescripcionProducto from './DescripcionProducto'
import { getEsquema } from './esquema'
import Exposicion from './exposicion/Exposicion'
import FechaPublicacion from './FechaPublicacion'
import IndicarCategorias from './IndicarCategorias'
import IndicarEtiquetas from './IndicarEtiquetas'
import IndicarPrecio from './IndicarPrecio'
import IndicarProducto from './IndicarProducto'
import IndicarProductoEstado from './IndicarProductoEstado'
import ListaDeVentas from './ListaDeVentas'
import Ofertas from './Ofertas'
import './Publicar.css'
import { PublicacionMasiva } from './PublicacionMasiva'
import TipoPublicacion from './TipoPublicacion'
import VentasEspeciales from './VentasEspeciales'

const CENTER_DIVISOR = 2
const DIAS_MOSTRAR_BORRADOR = 2
const ENVIO_GRATIS = 1
const RETIRA_COMPRADOR = 2
const ENVIO_A_CARGO_COMPRADOR = 3
const OFFSET = -300
const PASO = {
  PRINCIPIO: -1,
  TITULO: 0,
  DESCRIPCION: 1,
  FECHA_PUBLICACION: 2,
  LISTA_VENTAS: 3,
  ETIQUETAS: 4,
  CATEGORIA: 5,
  CARACTERISTICAS: 6,
  ESTADO_PRODUCTO: 7,
  IMAGENES: 8,
  PRECIO: 9,
  VENTAS_ESPECIALES: 10,
  OFERTA: 11,
  FINAL: 12
}

const Publicar = ({ Validador }) => {
  const navigate = useNavigate()
  const { loginDataContext } = useContext(LoginContext)

  // Initial publicacion object
  const initialPublicacion = {
    alicuota: 0,
    idPublicacionTemporal: 0,
    idVendedor: loginDataContext?.idUsuario || 0,
    titulo: '',
    descripcion: '',
    desde: Moment().format('YYYY-MM-DD'),
    hasta: '',
    idListaVenta: 0,
    etiquetas: '',
    idCategoria: 0,
    metadatos: [],
    esNuevo: null,
    esScrap: false,
    youtube: '',
    conStock: false,
    conStockAPedido: false,
    conPresupuesto: false,
    cantDisponible: 0,
    cantMinPedido: 0,
    precioUnitario: 0,
    envioGratis: false,
    preciosMayorista: [
      {
        cantidad: 0,
        idUnidadMedida: 0,
        precio: 0,
        id: 0
      }
    ],
    tipoProducionCant: 0,
    tipoProducionUnidad: 0,
    idMoneda: 0,
    capacidadMax: 0,
    extensionGarantia: false,
    mediosPagos: [],
    mediosEnvios: [],
    garantias: [],
    garantiaPlazo: 0,
    garantiaMonto: 0,
    porcDcto: 0,
    ofertaDesde: null,
    ofertaHasta: null,
    idPublicacionExposicion: 0,
    nombreListaEnvio: '',
    cantDiasEnvioGratis: null,
    cantDiasRetiroComprador: null,
    descZona: '',
    descZonaRetiro: '',
    tipoProducto: ''
  }

  // State
  const [errores, setErrores] = useState({})
  const [idPublicacionTemporal, setIdPublicacionTemporal] = useState(0)
  const [paso, setPaso] = useState(PASO.PRINCIPIO)
  const idVendedor = loginDataContext?.idUsuario || 0
  const [verCategoriasPrincipales, setVerCategoriasPrincipales] = useState(false)
  const [publicacion, setPublicacion] = useState(initialPublicacion)
  const [esMasiva, setEsMasiva] = useState(false)
  const [publicacionTemporal, setPublicacionTemporal] = useState(initialPublicacion)
  const vigenciaManualRef = useRef({
    desde: initialPublicacion.desde,
    hasta: initialPublicacion.hasta
  })
  const dispatch = useDispatch()
  const modalRestaurarAbiertoRef = useRef(false)
  const confirmandoRestauracionRef = useRef(false)
  const activoRef = useRef(false)
  const scrollRestauracionRef = useRef(false)
  const pasoRefs = useRef({})
  const pasoRefSetters = useRef({})

  const getPasoElemento = useCallback((paso) => pasoRefs.current[paso] || null, [])

  const setPasoRef = useCallback((paso) => {
    if (!pasoRefSetters.current[paso]) {
      pasoRefSetters.current[paso] = (p) => {
        pasoRefs.current[paso] = p
      }
    }
    return pasoRefSetters.current[paso]
  }, [])

  // Mount effect
  useEffect(() => {
    Events.scrollEvent.register('begin', () => {})

    Events.scrollEvent.register('end', (to) => {
      to === 'pasoArriba' && setVerCategoriasPrincipales(false)
    })

    return () => {
      Events.scrollEvent.remove('begin')
      Events.scrollEvent.remove('end')
      document.body.classList.remove('sin-scroll')
    }
  }, [])

  const getAlto = useCallback(
    (pasoNum) => {
      const refPasoActual = getPasoElemento(pasoNum)
      const refPasoAnterior = getPasoElemento(pasoNum - 1)

      if (refPasoActual && refPasoAnterior) {
        return (refPasoActual.offsetHeight - refPasoAnterior.offsetHeight) / CENTER_DIVISOR
      }
      return 0
    },
    [getPasoElemento]
  )

  const getAltos = useCallback(
    (cantPasos) => {
      let offSetCalc = 0
      for (let i = 0; i < cantPasos; i++) {
        offSetCalc += getAlto(cantPasos - i)
      }
      return offSetCalc
    },
    [getAlto]
  )

  const moverScroll = useCallback(() => {
    if (paso <= PASO.FINAL) {
      const offSetCalc = OFFSET + getAltos(paso)

      scroller.scrollTo('borde-normal-active', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: offSetCalc
      })
    }
  }, [paso, getAltos])

  const openConfirm = async (data) => {
    if (modalRestaurarAbiertoRef.current) {
      return
    }

    modalRestaurarAbiertoRef.current = true
    const publicacionGuardada = JSON.parse(data.publicacion)

    setPublicacionTemporal(data)
    dispatch(
      setModal({
        size: 'sm',
        title: 'Restaurar publicación',
        type: 'botones',
        body: `Se encontró una publicación sin publicar${publicacionGuardada?.titulo ? ` con el título ${publicacionGuardada.titulo}` : ''}.
               ¿Desea continuar con esa publicación?
               En caso de no restaurarla, el borrador será eliminado.`,
        show: true,
        modalId: 'restaurar-publicacion'
      })
    )
  }

  useEffect(() => {
    if (!idVendedor) {
      return
    }

    activoRef.current = true
    obtenerPublicacionPendiente()

    return () => {
      activoRef.current = false
    }
  }, [idVendedor])

  const obtenerPublicacionPendiente = async () => {
    const { data } = await publicacionService.obtenerUltimaNoPublicada(idVendedor)

    if (!data) {
      return
    }

    const fechaPublicacion = JSON.parse(data.publicacion).fechaPublicacion
    if (!fechaPublicacion) {
      return
    }
    const esReciente =
      Moment().startOf('day').diff(Moment(fechaPublicacion).startOf('day'), 'days') <=
      DIAS_MOSTRAR_BORRADOR

    if (!esReciente || !activoRef.current) {
      return
    }

    openConfirm(data)
  }

  const restaurarPublicacion = () => {
    if (!publicacionTemporal?.publicacion) {
      return true
    }

    confirmandoRestauracionRef.current = true
    const publicacionGuardada = JSON.parse(publicacionTemporal.publicacion)

    const pubFinal = {
      ...initialPublicacion,
      ...publicacionGuardada,
      idVendedor: idVendedor
    }
    setIdPublicacionTemporal(publicacionTemporal.idPublicacionTemporal)
    setPublicacion(pubFinal)
    setPaso(PASO.TITULO)
    scrollRestauracionRef.current = true
    dispatch(setModal({ show: false }))
    return true
  }

  const handleCerrarModalRestaurar = async () => {
    modalRestaurarAbiertoRef.current = false

    const confirmo = confirmandoRestauracionRef.current
    confirmandoRestauracionRef.current = false
    if (!confirmo) {
      await eliminarBorrador()
    }
    dispatch(setModal({ show: false, modalId: 'restaurar-publicacion' }))
  }

  const eliminarBorrador = async () => {
    try {
      if (publicacionTemporal?.idPublicacionTemporal) {
        await publicacionService.eliminarPublicacionTemporal(
          publicacionTemporal.idPublicacionTemporal
        )
        toast.success('El borrador se ha eliminado correctamente.')
      }
    } catch (error) {
      const mensaje = 'Ocurrió un error al eliminar el borrador.'
      toastErrorLog(error, mensaje, 'publicaciones')
    }
  }

  useEffect(() => {
    if (scrollRestauracionRef.current) {
      requestAnimationFrame(() => {
        const refDestino = getPasoElemento(paso)

        if (refDestino) {
          refDestino.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }

        scrollRestauracionRef.current = false
      })
      return
    }

    if (paso === PASO.PRINCIPIO) {
      scroller.scrollTo('pasoArriba', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -150
      })
      return
    }

    moverScroll()
  }, [paso, moverScroll, getPasoElemento])

  const handleTipoPublicacion = (masiva) => {
    setVerCategoriasPrincipales(true)
    setTimeout(() => {
      scroller.scrollTo('divCategorias', {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: 0
      })
    }, 0)
    setEsMasiva(masiva)
  }

  const irAPaso = (siguiente) => {
    setPaso((prevPaso) => prevPaso + (siguiente ? 1 : -1))
  }

  const handlePasoAnterior = () => {
    const pasoAnterior = paso - 1
    irAPaso(false)

    setTimeout(() => {
      const prevRef = getPasoElemento(pasoAnterior)
      if (prevRef) {
        prevRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)
    submit()
  }

  const irAPasoConError = (pasoError) => {
    setPaso(pasoError)
    setTimeout(() => {
      const ref = getPasoElemento(pasoError)
      if (ref) {
        ref.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)
  }

  const pasoValido = useCallback(
    (name, value) => {
      const datosActualizados = {
        ...publicacion,
        [name]: value
      }
      const datosParaValidarBase = value === undefined ? publicacion : datosActualizados

      const datosParaValidar = {
        ...datosParaValidarBase,
        tieneRetiro: datosParaValidarBase.mediosEnvios?.some(
          (m) => m.idMedioEnvio === RETIRA_COMPRADOR
        ),
        tieneEnvioGratis: datosParaValidarBase.mediosEnvios?.some(
          (m) => m.idMedioEnvio === ENVIO_GRATIS
        )
      }
      const erroresValidation = Validador.validarDato(getEsquema(), datosParaValidar, name)
      setErrores(erroresValidation || {})
      if (erroresValidation) {
        return false
      } else {
        return true
      }
    },
    [publicacion, Validador]
  )

  const valido = useCallback(
    (pasoNum, name) => (paso === pasoNum && !pasoValido(name) ? false : true),
    [paso, pasoValido]
  )

  const handlePasoSiguiente = () => {
    if (paso === PASO.TITULO) {
      Validador.cargarEsquema(getEsquema())
    }

    if (!valido(PASO.TITULO, 'titulo')) {
      return
    }
    if (!valido(PASO.DESCRIPCION, 'descripcion')) {
      return
    }
    if (!valido(PASO.FECHA_PUBLICACION, 'desde') || !valido(PASO.FECHA_PUBLICACION, 'hasta')) {
      return
    }
    if (!valido(PASO.CATEGORIA, 'idCategoria')) {
      return
    }
    if (!valido(PASO.ESTADO_PRODUCTO, 'esNuevo')) {
      return
    }
    if (
      !valido(PASO.PRECIO, 'idMoneda') ||
      !valido(PASO.PRECIO, 'precioUnitario') ||
      !valido(PASO.PRECIO, 'alicuota') ||
      !valido(PASO.PRECIO, 'cantDisponible')
    ) {
      return
    }

    if (
      !valido(PASO.OFERTA, 'porcDcto') ||
      !valido(PASO.OFERTA, 'ofertaDesde') ||
      !valido(PASO.OFERTA, 'ofertaHasta')
    ) {
      return
    }
    if (
      !valido(PASO.VENTAS_ESPECIALES, 'mediosPagos') ||
      !valido(PASO.VENTAS_ESPECIALES, 'mediosEnvios') ||
      !valido(PASO.VENTAS_ESPECIALES, 'cantDiasEnvioGratis') ||
      !valido(PASO.VENTAS_ESPECIALES, 'cantDiasRetiroComprador') ||
      !valido(PASO.VENTAS_ESPECIALES, 'descZona') ||
      !valido(PASO.VENTAS_ESPECIALES, 'descZonaRetiro')
    ) {
      return
    }

    if (publicacion.mediosEnvios.some((m) => m.idMedioEnvio === ENVIO_A_CARGO_COMPRADOR)) {
      if (!publicacion.idListaEnvio || publicacion.idListaEnvio === 0) {
        setErrores((prev) => ({
          ...prev,
          idListaEnvio: 'Debe seleccionar una lista de envíos.'
        }))
        irAPasoConError(PASO.VENTAS_ESPECIALES)
        return
      }
    }

    if (paso < PASO.FINAL) {
      irAPaso(true)
    }

    setTimeout(() => {
      const nextRef = getPasoElemento(paso + 1)
      if (nextRef) {
        nextRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 0)
    submit()
  }

  const obtenerValor = (value, valueCalculado, checked, type, tipoDato) => {
    let val
    switch (tipoDato) {
      case 'bool':
        val = value === 'true'
        break
      case 'num':
        val = Number(value)
        break
      case 'calc':
        val = valueCalculado
        break
      default:
        val = type === 'checkbox' || type === 'radio' ? checked : value
        break
    }
    return val
  }

  const handleChangeState = (name, value, callBack) => {
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
    if (callBack) {
      callBack()
    }
  }

  const handleChange = ({ currentTarget: input }, tipoDato = '', valueCalculado = null) => {
    const { name, value, checked, type } = input
    const nuevoValor = obtenerValor(value, valueCalculado, checked, type, tipoDato)

    if (name === 'descZona' || name === 'descZonaRetiro') {
      setPublicacion((prevState) => ({
        ...prevState,
        [name]: nuevoValor
      }))
    } else if (name === 'cantDiasEnvioGratis' || name === 'cantDiasRetiroComprador') {
      const valorDias =
        value === '' || value === null || value === undefined ? null : parseInt(value, 10)
      setPublicacion((prevState) => ({
        ...prevState,
        [name]: Number.isNaN(valorDias) ? null : valorDias
      }))
    } else {
      pasoValido(input.name, nuevoValor)
      moverScroll()
      handleChangeState(name, nuevoValor, () => pasoValido(name, nuevoValor))

      if ((name === 'desde' || name === 'hasta') && !Number(publicacion.idListaVenta)) {
        vigenciaManualRef.current = {
          ...vigenciaManualRef.current,
          [name]: nuevoValor
        }
      }
    }
  }

  const handleListaVentaChange = (listaSeleccionada) => {
    setPublicacion((prevState) => {
      if (listaSeleccionada && Number(listaSeleccionada.value) > 0) {
        if (!Number(prevState.idListaVenta)) {
          vigenciaManualRef.current = {
            desde: prevState.desde,
            hasta: prevState.hasta
          }
        }

        return {
          ...prevState,
          desde: listaSeleccionada.vigenciaDesde || prevState.desde,
          hasta: listaSeleccionada.vigenciaHasta || prevState.hasta
        }
      }

      if (Number(prevState.idListaVenta)) {
        return {
          ...prevState,
          desde: vigenciaManualRef.current.desde || prevState.desde,
          hasta: vigenciaManualRef.current.hasta || prevState.hasta
        }
      }

      return prevState
    })
  }

  useEffect(() => {
    if (!Number(publicacion.idListaVenta)) {
      vigenciaManualRef.current = {
        desde: publicacion.desde,
        hasta: publicacion.hasta
      }
    }
  }, [publicacion.idListaVenta, publicacion.desde, publicacion.hasta])

  const handleGarantia = (name, value) => {
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }

  const submit = async () => {
    const publicacionData = {
      ...publicacion,
      idVendedor: idVendedor,
      cantDiasEnvioGratis: publicacion.cantDiasEnvioGratis
        ? parseInt(publicacion.cantDiasEnvioGratis, 10)
        : null,
      cantDiasRetiroComprador: publicacion.cantDiasRetiroComprador
        ? parseInt(publicacion.cantDiasRetiroComprador, 10)
        : null,
      fechaPublicacion: new Date().toISOString()
    }

    const publicacionPayload = {
      publicacion: JSON.stringify(publicacionData),
      idPublicacionTemporal: idPublicacionTemporal,
      idVendedor: idVendedor
    }

    if (idPublicacionTemporal === 0) {
      const { data } = await publicacionService.insertar(publicacionPayload)
      setIdPublicacionTemporal(data.idPublicacionTemporal)
      setPublicacion((prevState) => ({
        ...prevState,
        idPublicacionTemporal: data.idPublicacionTemporal
      }))
    } else {
      await publicacionService.actualizar(publicacionPayload)
    }
  }

  const handlerPublicar = async () => {
    try {
      if (!pasoValido('idPublicacionExposicion')) {
        return
      }

      if (Object.keys(errores).length) {
        return false
      }

      await publicacionService.publicar(publicacion)
      limpiarForm()

      navigate('/PublicacionGrabada')
    } catch (error) {
      const mensaje = `Ocurrió un error al publicar.`
      toastErrorLog(error, mensaje, 'publicaciones')
    }
  }

  const limpiarForm = () => {
    setErrores({})
    setIdPublicacionTemporal(0)
    setPaso(PASO.PRINCIPIO)
    setVerCategoriasPrincipales(false)
    setPublicacion(initialPublicacion)
  }

  const claseActivo = (posicion) => (paso === posicion ? true : false)

  const getErrores = (arrElementos) => {
    let error = null
    arrElementos.forEach((e) => {
      if (errores[e]) {
        error = errores[e]
      }
    })
    return error
  }

  const handleTab = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault()
      handlePasoSiguiente()
    }
    if (e.shiftKey && e.key === 'Tab') {
      e.preventDefault()
      handlePasoAnterior()
    }
  }

  const setCatalogo = (tipoValue) => {
    if (!tipoValue) {
      return
    }

    setPublicacion((prev) => ({
      ...prev,
      esScrap: tipoValue.esScrap,
      tipoProducto: tipoValue.nombre
    }))
    setPaso(PASO.TITULO)
  }

  return (
    <form onSubmit={(e) => e.preventDefault()} onKeyDown={(e) => handleTab(e)}>
      <div className="pasoArriba">
        <div className="box-publicar">
          <h1 className="text-center">
            Bienvenido! <br /> Comencemos con la publicación...
          </h1>
        </div>
        <TipoPublicacion onClick={handleTipoPublicacion} />

        {verCategoriasPrincipales && (
          <div className="divCategorias">
            <CategoriasPrincipales onClick={setCatalogo} selectedTipo={publicacion.tipoProducto} />
          </div>
        )}
        {paso >= PASO.TITULO &&
          (esMasiva ? (
            <PublicacionMasiva errores={errores} handleChange={handleChange} />
          ) : (
            <div className="row">
              <div className="col-10">
                <Borde
                  titulo="Indicá el título de tu publicación"
                  activo={claseActivo(PASO.TITULO)}
                  ref={setPasoRef(PASO.TITULO)}
                  error={errores.titulo}
                >
                  <IndicarProducto onChange={handleChange} value={publicacion.titulo} />
                </Borde>
                <Borde
                  titulo="Escribí la descripción de tu publicación"
                  activo={claseActivo(PASO.DESCRIPCION)}
                  ref={setPasoRef(PASO.DESCRIPCION)}
                  error={errores.descripcion}
                >
                  <DescripcionProducto onChange={handleChange} value={publicacion.descripcion} />
                </Borde>
                <Borde
                  titulo="Fecha de Publicación"
                  activo={claseActivo(PASO.FECHA_PUBLICACION)}
                  ref={setPasoRef(PASO.FECHA_PUBLICACION)}
                  error={errores.desde ? errores.desde : errores.hasta}
                >
                  <FechaPublicacion onChange={handleChange} publicacion={publicacion} />
                </Borde>
                <Borde
                  titulo="Lista de Ventas"
                  activo={claseActivo(PASO.LISTA_VENTAS)}
                  ref={setPasoRef(PASO.LISTA_VENTAS)}
                >
                  <ListaDeVentas
                    idVendedor={idVendedor}
                    onChange={handleChange}
                    onChangeState={handleChangeState}
                    onListaVentaChange={handleListaVentaChange}
                    value={publicacion.idListaVenta}
                  />
                </Borde>
                <Borde
                  titulo="Indicá las etiquetas de tu publicación"
                  activo={claseActivo(PASO.ETIQUETAS)}
                  ref={setPasoRef(PASO.ETIQUETAS)}
                >
                  <IndicarEtiquetas
                    onChangeState={handleChangeState}
                    value={publicacion.etiquetas}
                  />
                </Borde>
                <Borde
                  titulo="Indicá a que categoría pertenece"
                  activo={claseActivo(PASO.CATEGORIA)}
                  ref={setPasoRef(PASO.CATEGORIA)}
                  error={errores.idCategoria}
                >
                  <IndicarCategorias
                    onChange={handleChange}
                    value={publicacion.idCategoria}
                    esScrap={publicacion.esScrap}
                  />
                </Borde>
                <Borde
                  titulo="Indicá las características de tu publicación"
                  activo={claseActivo(PASO.CARACTERISTICAS)}
                  ref={setPasoRef(PASO.CARACTERISTICAS)}
                >
                  <Metadatos
                    value={{ metadatos: publicacion.metadatos }}
                    idCategoria={publicacion.idCategoria}
                    esPublicar={true}
                    editable={true}
                    onChange={handleChange}
                  />
                </Borde>
                <Borde
                  titulo="Indicá el estado de tu publicación"
                  activo={claseActivo(PASO.ESTADO_PRODUCTO)}
                  ref={setPasoRef(PASO.ESTADO_PRODUCTO)}
                  error={errores.esNuevo}
                >
                  <IndicarProductoEstado onChange={handleChange} checked={publicacion.esNuevo} />
                </Borde>
                <Borde
                  titulo="Agregá las fotos de tu publicación"
                  activo={claseActivo(PASO.IMAGENES)}
                  ref={setPasoRef(PASO.IMAGENES)}
                >
                  <AgregarFotos
                    value={publicacion.youtube}
                    idPublicacion={0}
                    idPublicacionTemporal={publicacion.idPublicacionTemporal}
                    onChange={handleChange}
                  />
                </Borde>
                <Borde
                  titulo="Indicá el precio de tu publicación"
                  activo={claseActivo(PASO.PRECIO)}
                  ref={setPasoRef(PASO.PRECIO)}
                  error={getErrores(['cantDisponible', 'precioUnitario', 'idMoneda', 'alicuota'])}
                >
                  <IndicarPrecio
                    values={{
                      conStock: publicacion.conStock,
                      conStockAPedido: publicacion.conStockAPedido,
                      conPresupuesto: publicacion.conPresupuesto,
                      cantDisponible: publicacion.cantDisponible,
                      cantMinPedido: publicacion.cantMinPedido,
                      precioUnitario: publicacion.precioUnitario,
                      idMoneda: publicacion.idMoneda,
                      preciosMayorista: publicacion.preciosMayorista,
                      capacidadMax: publicacion.capacidadMax,
                      alicuota: publicacion.alicuota,
                      tipoProducionCant: publicacion.tipoProducionCant,
                      tipoProducionUnidad: publicacion.tipoProducionUnidad
                    }}
                    onChange={handleChange}
                    onChangeState={handleChangeState}
                  />
                </Borde>
                <Borde
                  titulo="Condiciones de Venta Especiales"
                  activo={claseActivo(PASO.VENTAS_ESPECIALES)}
                  ref={setPasoRef(PASO.VENTAS_ESPECIALES)}
                  error={getErrores([
                    'mediosPagos',
                    'mediosEnvios',
                    'envioGratis',
                    'idListaEnvio',
                    'cantDiasEnvioGratis',
                    'cantDiasRetiroComprador',
                    'descZona',
                    'descZonaRetiro'
                  ])}
                >
                  <VentasEspeciales
                    values={{
                      extensionGarantia: publicacion.extensionGarantia,
                      garantiaPlazo: publicacion.garantiaPlazo,
                      garantiaMonto: publicacion.garantiaMonto,
                      mediosPagos: publicacion.mediosPagos,
                      mediosEnvios: publicacion.mediosEnvios,
                      garantias: publicacion.garantias,
                      envioGratis: publicacion.envioGratis,
                      nombreListaEnvio: publicacion.nombreListaEnvio,
                      idListaEnvio: publicacion.idListaEnvio,
                      descZona: publicacion.descZona,
                      descZonaRetiro: publicacion.descZonaRetiro,
                      cantDiasEnvioGratis: publicacion.cantDiasEnvioGratis,
                      cantDiasRetiroComprador: publicacion.cantDiasRetiroComprador
                    }}
                    onChange={handleChange}
                    onAddGarantia={handleGarantia}
                  />
                </Borde>
                <Borde
                  titulo="Oferta!"
                  activo={claseActivo(PASO.OFERTA)}
                  ref={setPasoRef(PASO.OFERTA)}
                  error={
                    errores.porcDcto
                      ? errores.porcDcto
                      : errores.ofertaDesde
                        ? errores.ofertaDesde
                        : errores.ofertaHasta
                  }
                >
                  <Ofertas
                    values={{
                      porcDcto: publicacion.porcDcto,
                      precioUnitario: publicacion.precioUnitario,
                      ofertaDesde: publicacion.ofertaDesde,
                      ofertaHasta: publicacion.ofertaHasta
                    }}
                    onChange={handleChange}
                  />
                </Borde>
                <Borde
                  titulo="Indicá la exposición de tu publicación"
                  activo={claseActivo(PASO.FINAL)}
                  ref={setPasoRef(PASO.FINAL)}
                  error={errores.idPublicacionExposicion}
                >
                  <Exposicion
                    onChange={handleChange}
                    checked={publicacion.idPublicacionExposicion}
                    precioUnitario={publicacion.precioUnitario}
                  />
                </Borde>
                {paso >= PASO.TITULO && (
                  <div className="row">
                    <div className="col-2"></div>
                    <div className="col">
                      <LinkButton className="btn-finalizar-publicacion" onClick={handlerPublicar}>
                        Finalizar la Publicación
                      </LinkButton>
                      <div style={{ marginBottom: '300px' }} />
                    </div>
                    <div className="col-2"></div>
                  </div>
                )}
              </div>
              <div className="col-2">
                <AsistenteFlechas
                  clickPasoAnterior={handlePasoAnterior}
                  clickPasoSiguiente={handlePasoSiguiente}
                  limiteInferior={paso === PASO.FINAL}
                  esPasoCero={paso === PASO.TITULO}
                ></AsistenteFlechas>
              </div>
            </div>
          ))}
      </div>
      <GenericModal
        modalId="restaurar-publicacion"
        onConfirm={restaurarPublicacion}
        onClose={handleCerrarModalRestaurar}
      />
    </form>
  )
}

Publicar.propTypes = {
  Validador: PropTypes.shape({
    validarDato: PropTypes.func.isRequired,
    cargarEsquema: PropTypes.func.isRequired
  }).isRequired
}

export default withValidador(Publicar)
